/**
 * Monta os envios do comentário da tarefa: texto sozinho, ou um item por arquivo
 * (a legenda e as menções vão no primeiro anexo, como no chat interno).
 */
export function buildTaskCommentSendItems({ body, mentions, files = [] } = {}) {
  const text = String(body || "").trim();
  const fileList = (Array.isArray(files) ? files : []).filter(Boolean);
  if (!fileList.length) {
    return text ? [{ body: text, mentions }] : [];
  }
  return fileList.map((file, index) => ({
    file,
    body: index === 0 ? text : "",
    mentions: index === 0 ? mentions : undefined,
  }));
}
